import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import PageWrapper from "../../../pagecomponents/Common/PageWrapper";
import DataTable from "../../../pagecomponents/Common/DataTable";
import {
  getReceivableData,
  getPrintData,
} from "../../../redux/slices/CustomerSlice";
import { toastMessage, number_format } from "../../../helpers/utility.js";
import DatePicker from "react-datepicker";
import { add, format } from "date-fns";
import {
  Row,
  InputGroup,
  Form,
  Button,
  Table,
  Col,
  Card,
} from "react-bootstrap";
import { CCol, CFormLabel, CFormFeedback, CFormInput } from "@coreui/react";
import { ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import useDebouncedValue from "../../../helpers/useDebouncedValue";

const PayableReport = () => {
  const dispatch = useDispatch();
  let pageName = "Payable Report";

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalPage, setTotalPage] = useState(0);

  const LIST_PARAMS = {
    skip: 0,
    take: rowsPerPage,
    type: "",
    filter: {
      voucher_payment_Type: "Supplier",
      voucher_payment_Data: 0,
      fromdate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)
        .toISOString()
        .split("T")[0], // 30 days back
      todate: new Date().toISOString().split("T")[0], // Today's date
      supplier_name: "",
    },
  };

  const [params, setParams] = useState(LIST_PARAMS);
  const [data, setData] = useState([]);
  const [customerNameFilter, setCustomerNameFilter] = useState("");
  const debouncedSupplierNameFilter = useDebouncedValue(customerNameFilter, 400);
  const [summaryData, setSummaryData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
 const navigate = useNavigate();
  const location = useLocation();

  const addStateToLocation = (data) => {
    navigate(location.pathname, {
      replace: true, // optional: prevents adding history entry
      state: {
        ...location.state,
        ...data,
      },
    });
  };


  useEffect(() => {
    addStateToLocation(params);
  }, [JSON.stringify(params)]);

  useEffect(() => {
    if (params.type === "print") {
      fetchPrintData();
    }
    if (params.type === "") {
      getComponentData();
    }
  }, [params]);

  useEffect(() => {
    setCurrentPage(1);
    setParams((prev) => {
      const currentFilterValue = String(prev?.filter?.supplier_name || "");
      if (currentFilterValue === debouncedSupplierNameFilter && prev.skip === 0) {
        return prev;
      }
      return {
        ...prev,
        skip: 0,
        filter: {
          ...prev.filter,
          supplier_name: debouncedSupplierNameFilter,
        },
      };
    });
  }, [debouncedSupplierNameFilter]);

  const getComponentData = async () => {
    setIsLoading(true);

    try {
      const { payload } = await dispatch(
        getReceivableData({ inputData: params })
      );
      const responseRows = Array.isArray(payload?.data) ? payload.data : [];
      const totalCount = Number(payload?.count || 0);
      setData(responseRows);
      setSummaryData(payload?.summary || {});
      setTotalPage(Math.ceil(totalCount / rowsPerPage));
    } catch (err) {
      toastMessage("error", "Failed to fetch data");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSort = (key) => {
    setCurrentPage(1);

    setParams((prev) => ({
      ...prev,
      skip: 0,
      sorting_key: key,
      sorting:
        prev.sorting_key === key && prev.sorting === "asc" ? "desc" : "asc",
    }));
  };

  const handleRowsPerPageChange = (rows) => {
    setRowsPerPage(rows);
    setCurrentPage(1);

    setParams((prev) => ({
      ...prev,
      take: rows,
      skip: 0,
    }));
  };

  const setPage = (pagenum) => {
    setCurrentPage(pagenum);
    setParams((prev) => ({
      ...prev,
      skip: (pagenum - 1) * rowsPerPage,
    }));
  };

  const columns = [
    { label: "Name", accessor: "name", sortable: true },
    { label: "Total Bill", accessor: "total_bill", sortable: true },
    { label: "Total Paid", accessor: "total_paid", sortable: true },
    { label: "Total Due", accessor: "total_due", sortable: true },
  ];

  const handleFilterParamsOnChange = (e, dateField = null, date = null) => {
    if (dateField) {
      setParams((prev) => ({
        ...prev,
        filter: {
          ...prev.filter,
          [dateField]: date ? format(new Date(date), "yyyy-MM-dd") : "",
        },
      }));
    } else {
      const { name, value } = e.target;
      setParams((prev) => ({
        ...prev,
        filter: {
          ...prev.filter,
          [name]: value,
        },
      }));
    }
  };

  const handleCustomerNameChange = (e) => {
    const value = e.target.value;
    setCustomerNameFilter(value);
  };

  const handleResetFilters = () => {
    setCurrentPage(1);
    setCustomerNameFilter("");
    setParams({ ...LIST_PARAMS, take: rowsPerPage, skip: 0 });
  };

  const handlePrint = () => {
    setParams((prev) => ({
      ...prev,
      type: "print",
    }));
  };

  const fetchPrintData = async () => {
    try {
      const { payload } = await dispatch(getPrintData({ inputData: params }));

      if (payload?.status === "success") {
        if (payload?.url) {
          window.open(payload.url, "_blank");
        } else {
          toastMessage("error", payload.msg || "File link not found");
        }
      } else {
        toastMessage("error", payload.msg || "Link not generated.");
      }
    } catch (err) {
      toastMessage("error", "Failed to fetch data");
    }
  };



  return (
    <>
      <ToastContainer />
      <PageWrapper
        pageName={"Supplier SOA - Payable Report"}
        headerBtnTitle="Print"
        onHeaderButtonClick={() => {
          handlePrint();
        }}
        showAddBtn={true}
      >
        {summaryData && (
          <Row className="row-sm">
            <Col xl={3} lg={6} md={6} xm={12}>
              <Card className=" sales-card circle-image4">
                <Row>
                  <div className="col-8">
                    <div className="ps-4 pt-4 pe-3 pb-4 pt-0">
                      <div className="">
                        <h6 className="mb-2 tx-12">TOTAL BILL</h6>
                      </div>
                      <div className="pb-0 mt-0">
                        <div className="d-flex">
                          <h4 className="tx-26 font-weight-semibold mb-2">
                            {number_format(summaryData.total_bill, 2)}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="circle-icon widget bg-warning-gradient text-center align-self-center warning-success overflow-hidden box-shadow-warning">
                      <i className="fas fa-file-alt tx-20 lh-lg text-white"></i>
                    </div>
                  </div>
                </Row>
              </Card>
            </Col>
            <Col xl={3} lg={6} md={6} xm={12}>
              <Card className=" sales-card circle-image2">
                <Row>
                  <div className="col-8">
                    <div className="ps-4 pt-4 pe-3 pb-4 pt-0">
                      <div className="">
                        <h6 className="mb-2 tx-12">TOTAL PAID</h6>
                      </div>
                      <div className="pb-0 mt-0">
                        <div className="d-flex">
                          <h4 className="tx-26 font-weight-semibold mb-2">
                            {number_format(summaryData.total_paid, 2)}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="circle-icon widget bg-success-gradient text-center align-self-center shadow-secondary overflow-hidden box-shadow-info">
                      <i className="fa fa-check-square tx-20 lh-lg text-white"></i>
                    </div>
                  </div>
                </Row>
              </Card>
            </Col>
            <Col xl={3} lg={6} md={6} xm={12}>
              <Card className=" sales-card circle-image3">
                <Row>
                  <div className="col-8">
                    <div className="ps-4 pt-4 pe-3 pb-4 pt-0">
                      <div className="">
                        <h6 className="mb-2 tx-12">TOTAL DUE</h6>
                      </div>
                      <div className="pb-0 mt-0">
                        <div className="d-flex">
                          <h4 className="tx-26 font-weight-semibold mb-2">
                            {number_format(summaryData.total_due, 2)}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-4">
                    <div className="circle-icon widget bg-danger-gradient text-center align-self-center shadow-success overflow-hidden box-shadow-success">
                      <i className="far fa-credit-card tx-20 lh-lg text-white"></i>
                    </div>
                  </div>
                </Row>
              </Card>
            </Col>
          </Row>
        )}

        <Row className="row-sm mb-3">
          <CCol md={4}>
            <CFormLabel
              className="main-content-label tx-11 tx-medium tx-gray-600"
              htmlFor="fromdate"
            >
              From
            </CFormLabel>
            <InputGroup className="input-group reactdate-pic">
              <InputGroup.Text className="input-group-text">
                <i className="typcn typcn-calendar-outline tx-24 lh--9 op-6"></i>
              </InputGroup.Text>
              <DatePicker
                className="form-control"
                name="fromdate"
                id="fromdate"
                selected={
                  params.filter.fromdate
                    ? new Date(params.filter.fromdate)
                    : null
                }
                onChange={(date) =>
                  handleFilterParamsOnChange(null, "fromdate", date)
                }
                dateFormat="yyyy-MM-dd"
              />
            </InputGroup>
            <CFormFeedback invalid>Select From Date</CFormFeedback>
          </CCol>
          <CCol md={4}>
            <CFormLabel
              className="main-content-label tx-11 tx-medium tx-gray-600"
              htmlFor="todate"
            >
              To
            </CFormLabel>
            <InputGroup className="input-group reactdate-pic">
              <InputGroup.Text className="input-group-text">
                <i className="typcn typcn-calendar-outline tx-24 lh--9 op-6"></i>
              </InputGroup.Text>
              <DatePicker
                className="form-control"
                name="todate"
                id="todate"
                selected={
                  params.filter.todate ? new Date(params.filter.todate) : null
                }
                onChange={(date) =>
                  handleFilterParamsOnChange(null, "todate", date)
                }
                dateFormat="yyyy-MM-dd"
              />
            </InputGroup>
            <CFormFeedback invalid>Select To Date</CFormFeedback>
          </CCol>
          <CCol md={3}>
            <CFormLabel
              className="main-content-label tx-11 tx-medium tx-gray-600"
              htmlFor="customer_Name"
            >
              Supplier Name
            </CFormLabel>
            <CFormInput
              type="text"
              id="customer_Name"
              name="customer_Name"
              value={customerNameFilter}
              onChange={handleCustomerNameChange}
              placeholder="Search by supplier name..."
            />
            <CFormFeedback invalid>Please Enter Supplier name</CFormFeedback>
          </CCol>
          <CCol
            md={1}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "left",
              paddingTop: "28px",
              paddingLeft: "20px",
            }}
          >
            <Row className="btn-animation">
              <Button
                variant=""
                type="button"
                className="btn btn-sm btn-primary ms-2"
                onClick={handleResetFilters}
              >
                Reset
              </Button>
            </Row>
          </CCol>
        </Row>

        <DataTable
          pageName={pageName}
          columns={columns}
          data={data}
          onSorting={handleSort}
          sortingState={{ key: params.sorting_key, order: params.sorting }}
          currentPage={currentPage}
          totalPages={totalPage}
          rowsPerPage={rowsPerPage}
          updateRowsPerPage={handleRowsPerPageChange}
          onPageChange={setPage}
          loader={isLoading}
        />
      </PageWrapper>
    </>
  );
};

export default PayableReport;
